import Loader from '@components/Loader';
import React from 'react';

import './PlaybackPreparingLoader.less';

function PlaybackPreparingLoader({ isVideo }: { isVideo?: boolean }) {
  return (
    <div className="media_viewer_playback_container">
      <div className="media_viewer_playback_container__content">
        <Loader spinSize={72} isSpinning={true} classNameWrapper="loader" />
        <div className="copy">
          {isVideo ? 'Preparing for playback...' : 'Preparing preview...'}
        </div>
      </div>
    </div>
  );
}

export default PlaybackPreparingLoader;
